{
  "(optional)": "(opciono)",
  "(required)": "(obavezno)"
}
